module.exports = __webpack_public_path__ + "static/media/bus6.948aea02.jpg";